import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Reveal from "./Reveal";
import { PROF_ORDER, PROF_IMG } from "./data";
import { useT } from "./i18n";

export default function Professions() {
  const { t } = useT();
  return (
    <section id="professions" className="scroll-mt-24 bg-[#FDFBF7] py-20">
      <div className="mx-auto max-w-6xl px-5">
        <Reveal>
          <p className="text-[11px] uppercase tracking-[0.22em] text-[#C4A46B]">{t.prof.eyebrow}</p>
          <h2 className="mt-3 max-w-2xl font-serif text-4xl leading-tight text-[#173A2C] sm:text-5xl">{t.prof.heading}</h2>
          <p className="mt-3 max-w-2xl text-base text-[#5C5855]">{t.prof.sub}</p>
        </Reveal>
        <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {PROF_ORDER.map((id, i) => {
            const c = t.prof.cards[id];
            return (
              <Reveal key={id} delay={(i % 3) + 1} className="group flex h-full flex-col overflow-hidden rounded-2xl border border-[#E8E4DB] bg-white card-lift">
                <div className="relative h-44 overflow-hidden">
                  <img src={PROF_IMG[id]} alt={c.label} loading="lazy" decoding="async" className="img-zoom h-full w-full object-cover" />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#173A2C]/55 to-transparent" />
                  <h3 className="absolute bottom-3 left-4 font-serif text-2xl text-white">{c.label}</h3>
                </div>
                <div className="flex flex-1 flex-col p-5">
                  <p className="text-sm leading-relaxed text-[#5C5855]">{c.blurb}</p>
                  <div className="mt-3 flex flex-wrap gap-1.5">
                    {c.skills.map((s) => (
                      <span key={s} className="rounded-full border border-[#E8E4DB] bg-[#FDFBF7] px-2.5 py-0.5 text-xs text-[#2C2A29]">{s}</span>
                    ))}
                  </div>
                  <div className="mt-4 flex items-center gap-4 border-t border-[#F0ECE3] pt-4 text-sm">
                    <Link to="/register" data-testid={`explore-talent-${id}`} className="inline-flex items-center gap-1 font-semibold text-[#1F4A38] transition-all hover:gap-2">
                      {t.prof.exploreTalent} <ArrowRight className="h-3.5 w-3.5" />
                    </Link>
                    <a href="#jobs" data-testid={`explore-jobs-${id}`} className="text-[#8a6f38] hover:text-[#6f5626]">{t.prof.seeJobs}</a>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
